import axios from "axios";

//  单点登录 /8080/auth/login
export const login = (ticket) => {
    const url = `/8080/auth/sso/login?ticket=${ticket}`;
    return axios.get(url, {});
};
